import { render, staticRenderFns } from "./AddressListCreate.vue?vue&type=template&id=35ced1a2"
import script from "./AddressListCreate.vue?vue&type=script&lang=ts"
export * from "./AddressListCreate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports